import { Button } from '@sunwebgroup/uds-ui/button'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { AuthConfirmationLayout } from '../AuthConfirmationLayout'
import styles from './ResetPasswordConfirmation.module.css'

export interface ResetPasswordConfirmationProps {
  email: string
  onBackToSignIn: () => void
}

export function ResetPasswordConfirmation({ email, onBackToSignIn }: ResetPasswordConfirmationProps) {
  const intl = useIntl()

  return (
    <AuthConfirmationLayout
      icon="LockClosed"
      title={intl.formatMessage({ id: 'auth_reset_password_confirmation_heading' })}
    >
      <Typography as="p" variant="body-m-regular-snug" className={styles.emailMessage}>
        {intl.formatMessage(
          { id: 'auth_reset_password_confirmation_email_message' },
          { email: <Typography as="span" variant="body-m-bold-snug">{email}</Typography> },
        )}
      </Typography>
      <Button type="button" variant="primary" fullWidth onClick={onBackToSignIn}>
        {intl.formatMessage({ id: 'auth_reset_password_confirmation_back_to_sign_in_label' })}
      </Button>
    </AuthConfirmationLayout>
  )
}
